module.exports = __webpack_public_path__ + "img/Травмы и их последствия.1c33ea11.jpg";